import { DatadogLogger } from './DatadogLogger';

import { useRef } from 'react';

/**
 * Returns a function that logs a DatadogLogger.error() at most once per component mount.
 * Useful for error conditions detected during render that should not be reported on every re-render.
 *
 * @example
 * const logErrorOnce = useLogErrorOnce();
 *
 * if (data == null) {
 *     logErrorOnce('Missing data for component', { componentName: 'MyComponent' });
 *     return null;
 * }
 */
export function useLogErrorOnce() {
    const hasLogged = useRef(false);

    return (message: string, context?: Record<string, unknown>) => {
        if (!hasLogged.current) {
            hasLogged.current = true;
            void DatadogLogger.error(message, context);
        }
    };
}
